<template>
  <div class="attr">
    <div class="head-wrapper">
      <div class="avatar-box">
        <img class="avatar" :src="dataSource.cover.value" />
      </div>
      <div class="preview-box">
        <div class="cv">{{ dataSource.baseAim.label.value }}：{{ dataSource.baseAim.value.value }}</div>
        <div class="name">{{ dataSource.name.value }} {{ dataSource.level.value }}</div>
        <div class="attr-wrapper">
          <div class="attr-item" v-for="key in Object.keys(dataSource.base)" :key="key">
            <div class="label">
              <img class="icon" src="@/assets/nikke_imgs/attr-icon.png" />
              <span class="txt"> {{ dataSource.base[key].label.value }}</span>
            </div>
            <div class="value">
              {{ dataSource.base[key].value.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="desc">{{ characterDataSource.js.text.value }}</div>
    <div class="list">
      <div class="item" v-for="key in Object.keys(dataSource.detail)" :key="key">
        <div class="value">
          {{ dataSource.detail[key].value.value }}
        </div>
        <div class="label">
          {{ dataSource.detail[key].label.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Attr",
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    characterDataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    dataSource:{
      deep:true,
      immediate:true,
      handler(object) {
        console.log(JSON.parse(JSON.stringify(object)));
        
      }
    }
  }
};
</script>

<style lang="less" scoped>
.attr {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  z-index: 3;
  width: 671px;
  position: relative;
  z-index: 3;
  padding: 20px 0 22px 10px;
  background: url("~@/assets/nikke_imgs/attr-top-bg.png") left top/100% 100% no-repeat;
  cursor: default;
  row-gap: 34px;
  .head-wrapper {
    display: flex;
    margin-left: 20px;
    column-gap: 20px;
    .avatar-box {
      position: relative;
      width: 106px;
      height: 142px;
      overflow: hidden;
      background: url("~@/assets/nikke_imgs/role-base-avatar.png") left top/cover no-repeat;
      .avatar {
        position: relative;
        top: 6px;
        left: 4px;
        display: block;
        width: 100%;
      }
    }
    .preview-box {
      flex-grow: 1;
      .cv {
        color: rgba(20, 38, 48, 0.7);
        font-size: 13px;
        padding-left: 140px;
        padding-top: 14px;
      }
      .name {
        position: relative;
        top: 8px;
        left: -11px;
        width: 100%;
        height: 45px;
        line-height: 45px;
        text-indent: 20px;
        color: #333;
        font-size: 20px;
        font-weight: bold;
        margin-top: 5px;
      }
      .attr-wrapper {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        padding-right: 40px;
        .attr-item {
          width: 98px;
          .label {
            border-bottom: 1px solid #cacdd0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 4px;
            .icon {
              width: 36px;
              height: 12px;
            }
            .txt {
              color: #142630;
              font-size: 14px;
            }
          }
          .value {
            color: #142630;
            font-size: 14px;
            margin-top: 6px;
          }
        }
      }
    }
  }
  .desc {
    position: relative;
    margin: 0 auto;
    width: 604px;
    &::before {
      content: "";
      position: absolute;
      top: -14px;
      left: -16px;
      width: 139px;
      height: 55px;
      background: url("~@/assets/nikke_imgs/block-radius.png") left top/cover no-repeat;
    }
  }
  .list {
    position: relative;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    justify-items: center;
    row-gap: 16px;
    margin: 0 auto;
    background-color: rgba(255, 255, 255, 0.15);
    border: 1px solid #ffffff;
    border-radius: 4px;
    padding: 19px 0;
    width: 620px;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.15), -4px 4px 1px 0px rgba(20, 38, 48, 0.07);
    &::before,
    &::after {
      content: "";
      position: absolute;
      width: 13px;
      height: 14px;
      background: url("~@/assets/nikke_imgs/block-radius-arrow.png") center/cover no-repeat;
    }
    &::before {
      top: -2px;
      left: -2px;
    }
    &::after {
      right: -2px;
      bottom: -2px;
      transform: rotate(180deg);
    }
    .item {
      display: flex;
      flex-direction: column;
      row-gap: 8px;
      align-items: center;
      justify-content: center;
      width: fit-content;
      .label {
        color: rgba(20, 38, 48, 0.7);
        font-size: 12px;
      }
      .value {
        color: #142630;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
}
</style>
